import Layout from 'components/Layout/Layout';
import MonthlyStatisticsChart from './MonthlyStatisticsChart';
import MonthlyStatisticsTable from './MonthlyStatisticsTable';
import NoDataText from 'components/Text/NoDataText';
import { useSumTwoArray } from 'hooks/useSumArray';
import useMonthlyXlsx from 'hooks/useMonthlyXlsx';
import months from 'consts/constants';
import { useAtomValue } from 'jotai';
import centerInforIdxAtom from 'atom/centerInforIdxAtom';
import companyIdxAtom from 'atom/companyIdxAtom';
import { useQuery } from '@tanstack/react-query';
import { QueryKeys, restfetcher } from 'queryClient';
import commonYearAtom from 'atom/commonYear';
import commonMonthAtom from 'atom/commonMonth';
import React from 'react';

const MontlyStatisticsLayout = () => {
  const centerIdx = useAtomValue(centerInforIdxAtom);
  const selectedYear = useAtomValue(commonYearAtom);
  const selectedMonth = useAtomValue(commonMonthAtom);
  const companyIdx = useAtomValue(companyIdxAtom);

  const param = {
    companyidx: companyIdx,
    centeridx: centerIdx,
    year: selectedYear,
    month: selectedMonth
  };

  const queryKey = [QueryKeys.MONTHLYCHART, param];

  const getChartData = useQuery({
    queryKey: queryKey,
    queryFn: () =>
      restfetcher({
        method: 'POST',
        path: 'dashboard/month/measurement/count',
        params: param
      }),
    enabled: !!companyIdx && !!selectedYear
  });

  const { data: chartData } = getChartData;

  const posture: number[] = chartData?.posture || [];
  const rom: number[] = chartData?.rom || [];
  const totalData = useSumTwoArray(posture, rom);

  const sumArray = (arrayData: number[]): number => {
    return arrayData.reduce(
      (accumulator, currentValue) => accumulator + currentValue,
      0
    );
  };

  const headerRow = ['구분', ...months, 'Total'];
  const dataRows = [
    ['Posture', ...posture, sumArray(posture)],
    ['ROM', ...rom, sumArray(rom)],
    ['Total', ...totalData, sumArray(totalData)]
  ];

  const { handleClickExcelDownload } = useMonthlyXlsx({ headerRow, dataRows });

  return (
    <>
      <Layout
        title="월별 검사 인원수"
        onExcelDownload={handleClickExcelDownload}
        result={chartData?.result}
      >
        {chartData?.result === 'success' ? (
          <>
            <MonthlyStatisticsTable
              posture={posture}
              rom={rom}
              totalData={totalData}
            />
            <MonthlyStatisticsChart
              posture={posture}
              rom={rom}
              totalData={totalData}
            />
          </>
        ) : (
          <NoDataText />
        )}
      </Layout>
    </>
  );
};

export default React.memo(MontlyStatisticsLayout);
